export class CONSTANT {
    // NOTE: keep variable same as value
    static jobPosts: string = 'jobPosts';
    static applicants: string = 'applicants';
    static members: string = 'members';
    static talentGroups: string = 'talentGroups';
    static talents: string = 'talents';
    static forms: string = 'forms';
    static connections: string = 'connections';
    static challenges: string = 'challenges';
    static drives: string = 'drives';
    static public: string = 'public';
    static private: string = 'private';
    static targetTalentGroupId = 'targetTalentGroupId';
    static TALENT_STATUS = 'talentStatus';
    static ADDED = 'added';

    static RECEIVED_JOB_APPLICATIONS: string = 'RECEIVED_JOB_APPLICATIONS';
    static SHORTLISTED: string = 'SHORTLISTED';
    static INTERVIEW: string = 'INTERVIEW';
    static OFFERED: string = 'OFFERED';
    static HIRED: string = 'HIRED';
    static NOT_SUITABLE: string = 'NOT_SUITABLE';
    static T_P_ALL_TALENT: string = 'T_P_ALL_TALENT';
    static JOB_POST_LIST: string = 'JOB_POST_LIST';
    static ASSIGN_TALENT_PLAN: string = 'ASSIGN_TALENT_PLAN';
    static DRIVE_DETAIL_TALENT: string = 'DRIVE_DETAIL_TALENT';
    static DRIVE_DETAIL_APPLICANT: string = 'DRIVE_DETAIL_APPLICANT';
    static ALL_APPLICANTS: string = 'ALL_APPLICANTS';
    static T_P_ALL_TALENT_DETAIL: string = 'T_P_ALL_TALENT_DETAIL';
    static COUPON_SHARE_LIST: string = 'COUPON_SHARE_LIST';
    static JP_D_MATCHING_TALENT_DETAIL: string = 'JP_D_MATCHING_TALENT_DETAIL';
    static FORM_SUBMISSION_DETAIL: string = 'FORM_SUBMISSION_DETAIL';
    static JP_D_ASSIGNED_TALENT: string = 'JP_D_ASSIGNED_TALENT';
    static COURSE_PROGRESS: string = 'COURSE_PROGRESS';
    static COMPETITION_ENROLMENTS: string = 'COMPETITION_ENROLMENTS';
    static COMPETITION_SUBMISSIONS: string = 'COMPETITION_SUBMISSIONS';
    static T_P_GROUP: string = 'T_P_GROUP';
    static MARK_ALL_AS_READ = 'MARK_ALL_AS_READ';
    static CLEAR_ALL = 'CLEAR_ALL';
    static TALENT_HAS_TAG_ID = 'TALENT_HAS_TAG_ID';
    static DRIVE = 'DRIVE';

    static TAG = 'TAG';
    static STATUS = 'STATUS';
    static GROUP = 'GROUP';
    static LOCAL_HOSTNAMES: string[] = ['localhost', '127.0.0.1'];
    static SERVICE_WORKER_SCRIPT: string = 'ngsw-worker.js';
}
